import { get } from 'lodash'
import PrismaUser from 'models/data/prisma/PrismaUser'
import PrismaToApiUser from '../mappings/PrismaToApiUser';
import moment from 'moment'

class ApiUser {
	static default = {
		id: "",
		firebaseId: "",
		firstName: "",
		lastName: "",
		stripeCustomerId: "",
		stripePlanId: "",
		hasSubscription: false,
		stripeSubscriptionEndsAt: 0,
		stripeSubscriptionId: "",
		email: "",
		subscriptionHasExpired: true,
        referralCode: "",
        lastFourDigitsOfCard: "",
        endOfCurrentBillingPeriod: moment().unix(),
        subscriptionHasBeenCancelled: true,
        isNewsletterSubscriber: false
	};

	static id = apiUser => get(apiUser, "id", ApiUser.default.id);

	static firebaseId = apiUser => get(apiUser, "firebaseId", ApiUser.default.firebaseId);

	static firstName = apiUser => get(apiUser, "firstName", ApiUser.default.firstName)

	static lastName = apiUser => get(apiUser, "lastName", ApiUser.default.lastName);

	static stripeCustomerId = apiUser =>
		get(apiUser, "stripeCustomerId", ApiUser.default.stripeCustomerId);

	static stripePlanId = apiUser => get(apiUser, "stripePlanId", ApiUser.default.stripePlanId);

	static hasSubscription = apiUser =>
        get(apiUser, "hasSubscription", ApiUser.default.hasSubscription);
        
	static stripeSubscriptionEndsAt = apiUser =>
		get(apiUser, "stripeSubscriptionEndsAt", ApiUser.default.stripeSubscriptionEndsAt);

	static stripeSubscriptionId = apiUser =>
		get(apiUser, "stripeSubscriptionId", ApiUser.default.stripeSubscriptionId);

	static email = apiUser => get(apiUser, "email", ApiUser.default.email);

	static subscriptionHasExpired = apiUser =>
		get(apiUser, "subscriptionHasExpired", ApiUser.default.subscriptionHasExpired);

	static referralCode = apiUser => get(apiUser, "referralCode", ApiUser.default.referralCode);

    static lastFourDigitsOfCard = apiUser => get(apiUser, 'lastFourDigitsOfCard', ApiUser.default.lastFourDigitsOfCard)

    static endOfCurrentBillingPeriod = apiUser => get(apiUser, 'endOfCurrentBillingPeriod', ApiUser.default.endOfCurrentBillingPeriod)

    static subscriptionHasBeenCancelled = apiUser => get(apiUser, 'subscriptionHasBeenCancelled', ApiUser.default.subscriptionHasBeenCancelled)

    static isNewsletterSubscriber = apiUser => get(apiUser, 'isNewsletterSubscriber', ApiUser.default.isNewsletterSubscriber)

	static async fetch(firebaseId) {
		const prismaUser = await PrismaUser.fetch(firebaseId);
		return PrismaToApiUser.map(prismaUser);
	}
}

export default ApiUser;